const addressService = {
  searchZipCode(zipcode) {
    return fetch(`https://viacep.com.br/ws/${zipcode}/json`, { method: 'GET' });
  },
};

export default addressService;



// WEBPACK FOOTER //
// ./src/services/AddressService.js